type ShapeWithItemType = { itemType: string };

export type DonationFundItemType = 'cash' | 'charity';
export type DeliverableItemType = 'product' | 'gift_card' | 'experience';
export type CatalogItemType = DonationFundItemType | DeliverableItemType;

export const isShapeWithCashOrCharityItemType = (shape: ShapeWithItemType): shape is { itemType: DonationFundItemType } => {
  return isCashOrCharityItemType(shape.itemType);
};
export const isCashOrCharityCatalogItem = isShapeWithCashOrCharityItemType;

export const isCashOrCharityItemType = (itemType: string): itemType is DonationFundItemType => {
  return itemType === 'cash' || itemType === 'charity';
};

export const isShapeWithDeliverableItemType = (shape: ShapeWithItemType): shape is { itemType: DeliverableItemType } => {
  return isDeliverableItemType(shape.itemType);
};
export const isDeliverableCatalogItem = isShapeWithDeliverableItemType;

export const isDeliverableItemType = (itemType: string): itemType is DeliverableItemType => {
  return !isCashOrCharityItemType(itemType);
};
